export const translations = {
  zh: {
    loading: "正在加载...",
    processing: "处理中...",
    error: "错误",
    success: "成功",

    login: "登录",
    logout: "退出",
    welcome: "欢迎",
    username: "用户名",
    password: "密码",
    loginButton: "登录",
    loggingIn: "登录中...",
    loginError: "登录失败",
    loginErrorMsg: "登录过程中发生错误，请重试",
    loginFailed: "登录失败",
    loginException: "登录过程中发生异常，请重试",
    pleaseEnterUsernamePassword: "请输入用户名和密码",
    experienceGlobal: "体验全球最刺激的 2048 竞技",

    game: "游戏",
    globalRank: "全球排行",
    globalSkillRank: "全球技能排行榜",
    gameTitle: "2048 Clash: Global Skill Rank",
    gameOver: "游戏结束",
    currentScore: "当前分数",
    restart: "重新开始",
    myStats: "我的统计",
    totalGames: "总游戏数",
    bestScore: "最高分",
    averageScore: "平均分",
    lowestScore: "最低分",
    bestScores: "最佳成绩",
    noGameRecords: "还没有游戏记录",
    startGameCreateRecord: "开始游戏创造你的记录吧！",
    recentScores: "最近分数",
    startGameCreateRecords: "开始游戏创建记录吧！",
    victory: "胜利",
    retry: "重试",
    uploadingScore: "正在上传分数...",
    uploadSuccess: "分数已成功上传到服务端",
    uploadFailed: "上传失败",
    uploadInfo: "用户未登录，分数仅保存到本地",
    saveScoreFailed: "保存分数失败，请重试",
    retryingUpload: "正在重试上传...",

    competeWithGlobalPlayers: "与全球玩家一较高下",
    loadingGlobalRank: "加载全球排名中...",
    loadFailed: "加载失败",
    noRankingData: "暂无排行榜数据",
    beFirstPlayer: "还没有玩家上传分数，成为第一个上榜的玩家吧！",
    rank: "排名",
    player: "玩家",
    score: "分数",
    level: "等级",
    points: "分",
    showMore: "显示更多",
    remaining: "条剩余",
    rankUpdateEvery5Min: "排行榜每5分钟更新一次",
    continueGameImproveRank: "继续游戏提升你的排名！",

    switchToEnglish: "切换到英文",
    switchToChinese: "切换到中文",
    chinese: "中文",
    english: "English",
    settings: "设置",
    language: "语言",

    legend: "Legend",
    master: "Master",
    expert: "Expert",
    advanced: "Advanced",
    intermediate: "Intermediate",
    beginner: "Beginner",

    myScoreRecords: "我的得分记录",
    welcomeBack: "欢迎回来",
    player: "玩家",
    totalGames: "总游戏数",
    bestScore: "最高分",
    averageScore: "平均分",
    winRate: "胜率",
    recentGameRecords: "最近游戏记录",
    noGameRecords: "还没有游戏记录",
    startGameCreateFirstRecord: "开始游戏来创建你的第一个记录吧！",
    victory: "胜利",
    defeat: "失败",
  },
  en: {
    // Common
    loading: "Loading...",
    processing: "Processing...",
    error: "Error",
    success: "Success",

    // Login related
    login: "Login",
    logout: "Logout",
    welcome: "Welcome",
    username: "Username",
    password: "Password",
    loginButton: "Login",
    loggingIn: "Logging in...",
    loginError: "Login Failed",
    loginErrorMsg: "An error occurred during login, please try again",
    loginFailed: "Login failed",
    loginException: "An exception occurred during login, please try again",
    pleaseEnterUsernamePassword: "Please enter username and password",
    experienceGlobal: "Experience the most exciting 2048 competition globally",

    // Game related
    game: "Game",
    globalRank: "Global Rank",
    globalSkillRank: "Global Skill Rank",
    gameTitle: "2048 Clash: Global Skill Rank",
    gameOver: "Game Over",
    currentScore: "Current Score",
    restart: "Restart",
    myStats: "My Stats",
    totalGames: "Total Games",
    bestScore: "Best Score",
    averageScore: "Average Score",
    lowestScore: "Lowest Score",
    bestScores: "Best Scores",
    noGameRecords: "No game records yet",
    startGameCreateRecord: "Start playing to create your records!",
    recentScores: "Recent Scores",
    startGameCreateRecords: "Start playing to create records!",
    victory: "Victory",
    retry: "Retry",
    uploadingScore: "Uploading score...",
    uploadSuccess: "Score successfully uploaded to server",
    uploadFailed: "Upload failed",
    uploadInfo: "User not logged in, score saved locally only",
    saveScoreFailed: "Failed to save score, please retry",
    retryingUpload: "Retrying upload...",

    // Leaderboard related
    competeWithGlobalPlayers: "Compete with global players",
    loadingGlobalRank: "Loading global rankings...",
    loadFailed: "Load Failed",
    noRankingData: "No ranking data available",
    beFirstPlayer:
      "No players have uploaded scores yet, be the first to make it to the leaderboard!",
    rank: "Rank",
    player: "Player",
    score: "Score",
    level: "Level",
    points: "pts",
    showMore: "Show More",
    remaining: "remaining",
    rankUpdateEvery5Min: "Leaderboard updates every 5 minutes",
    continueGameImproveRank: "Keep playing to improve your rank!",

    // Language switch
    switchToEnglish: "Switch to English",
    switchToChinese: "切换到中文",
    chinese: "中文",
    english: "English",
    settings: "Settings",
    language: "Language",

    // Levels
    legend: "Legend",
    master: "Master",
    expert: "Expert",
    advanced: "Advanced",
    intermediate: "Intermediate",
    beginner: "Beginner",

    // My Score related
    myScoreRecords: "My Score Records",
    welcomeBack: "Welcome back",
    player: "Player",
    totalGames: "Total Games",
    bestScore: "Best Score",
    averageScore: "Average Score",
    winRate: "Win Rate",
    recentGameRecords: "Recent Game Records",
    noGameRecords: "No game records yet",
    startGameCreateFirstRecord: "Start playing to create your first record!",
    victory: "Victory",
    defeat: "Defeat",
  },
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.zh[key] || key;
};
